import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbShowMoreTextLink } from "abreact/layout/AbShowMoreTextLink";
import { useCurrentCallback, useCurrentValue, useResizeObserver } from "abreact/utils/AbHooks";
import { ElementUtils } from "abweb/utils/ElementUtils";
import * as React from "react";
export const AbShowMoreTextContainer = props => {
  const [scrollState, setScrollState] = React.useState("no-overflow");
  const onResize = useCurrentCallback(props.onResize ?? (() => {}));
  const scrollStateRef = useCurrentValue(scrollState);

  // Check to see if the content is longer than the collapsed max height -- if so, mark it as scrollable content so we
  // can decide whether to render the AbShowMoreTextLink
  const updateScrollState = () => {
    if (!outerRef.current || !innerRef.current) return;
    onResize();
    const innerHeight = innerRef.current.scrollHeight;
    const lineHeight = ElementUtils.getCssAsNumber("--ab-local-font-line-height", undefined, outerRef.current);
    const maxLinesCollapsed = ElementUtils.getCssAsNumber("--ab-show-more-text-max-lines-collapsed", undefined, outerRef.current);
    const maxCollapsedHeight = props.collapsedMaxHeightPixels ?? lineHeight * maxLinesCollapsed;
    switch (scrollStateRef.current) {
      case "no-overflow":
        if (innerHeight > maxCollapsedHeight) setScrollState("collapsed");
        break;
      case "expanded":
        if (innerHeight <= maxCollapsedHeight) setScrollState("no-overflow");
        break;
      case "collapsed":
        if (innerHeight <= maxCollapsedHeight) setScrollState("no-overflow");
        break;
    }
  };
  const toggleExpandedContent = () => {
    // Scroll to the top of the content when we are collapsing the container
    if (scrollState === "expanded" && innerRef.current) {
      innerRef.current.scrollTop = 0;
      Array.from(innerRef.current.children).forEach(el => el.scrollTop = 0);
    }
    onResize();
    setScrollState(scrollState === "expanded" ? "collapsed" : "expanded");
  };
  const outerRef = useResizeObserver(updateScrollState);
  const innerRef = useResizeObserver(updateScrollState);
  const getStateClassname = () => {
    switch (scrollState) {
      case "no-overflow":
        return "ab-show-more-text-container-no-overflow";
      case "expanded":
        return "ab-show-more-text-container-expanded";
      case "collapsed":
        return "ab-show-more-text-container-collapsed";
    }
  };
  const style = {
    ...props.style,
    "--ab-show-more-text-container-collapsed-max-height": props.collapsedMaxHeightPixels ? `${props.collapsedMaxHeightPixels}px` : undefined
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-show-more-text-container", props, [getStateClassname()]), {
    ref: outerRef,
    style: style
  }), /*#__PURE__*/React.createElement("div", {
    className: "ab-show-more-text-container-mask",
    ref: innerRef
  }, props.children), scrollState !== "no-overflow" && /*#__PURE__*/React.createElement(AbShowMoreTextLink, {
    onClick: toggleExpandedContent,
    isExpanded: scrollState === "expanded"
  }));
};
//# sourceMappingURL=AbShowMoreTextContainer.js.map
